import tinyColor from 'tinycolor2'

export const fade = (color, scale) => {
  let transparency = scale / 100
  transparency =
    color === '#000' || color === '#000000' ? transparency * 0.5 : transparency
  const rgbColor = tinyColor(color).toRgb()
  rgbColor.a = transparency
  return tinyColor(rgbColor).toRgbString()
}
